import React, { FC } from 'react';
import { PropertyType } from 'esa-ui-library/lib/types';
import styles from './PlayerInfo.module.scss';
import { isNil } from 'lodash';
import { formatCents } from '../../../../../common';
import { PlayerInfoItem } from './PlayerInfoItem/PlayerInfoItem';

interface PlayerInfoProps {
	player: PropertyType;
	fields: PropertyType[];
}

const PlayerInfo: FC<PlayerInfoProps> = ({ player, fields }): JSX.Element => {
	const formatValue = (value: string | number, isCurrency: boolean): string => {
		let result: string | null = '';
		if (isNil(value)) {
			result = '-';
		} else if (!isNil(value) && isCurrency) {
			result = formatCents(+value);
		} else {
			result = value.toString();
		}
		return result;
	};
	const renderInfoItems = () => {
		return fields.map((field) => (
			<PlayerInfoItem key={field.label} label={field.label} value={formatValue(player[field.key], field.isCurrency)} />
		));
	};
	return <section className={`${styles.PlayerInfo}`}>{renderInfoItems()}</section>;
};
export { PlayerInfo };
